<bb-common-error-state-ui
  [error]="pageNotFound"
></bb-common-error-state-ui>
